// extracted by mini-css-extract-plugin
export default {"root":"ChQ_EFOlLboRjYeLhmGE","item":"jqoSFJLGckb_o5lkp4vq","holiday":"wbnJfL0MrzRVBP_tj5cp","placeHolderShimmer":"SDyY9u9CkI4AFoYkca93"};